var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnalyzeLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.91176C0 4.71379 4.21379 0.5 9.41177 0.5H30.5882C35.7862 0.5 40 4.71379 40 9.91177V31.0882C40 36.2862 35.7862 40.5 30.5882 40.5H9.41176C4.21379 40.5 0 36.2862 0 31.0882V9.91176Z",
    fill: "#7951EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5C15.5817 10.5 12 14.0817 12 18.5V28.4C12 28.7314 11.7314 29 11.4 29H10.6C10.2686 29 10 28.7314 10 28.4V18.5C10 12.9772 14.4772 8.5 20 8.5C25.5228 8.5 30 12.9772 30 18.5V30.9C30 31.7837 29.2837 32.5 28.4 32.5H26.1C25.2163 32.5 24.5 31.7837 24.5 30.9V25H18.6C17.7163 25 17 24.2837 17 23.4V21.1C17 20.2163 17.7163 19.5 18.6 19.5H24.5V18.5C24.5 16.0147 22.4853 14 20 14C17.5147 14 15.5 16.0147 15.5 18.5V30.9C15.5 31.7837 14.7837 32.5 13.9 32.5H10.6C10.2686 32.5 10 32.2314 10 31.9V31.1C10 30.7686 10.2686 30.5 10.6 30.5H13.5V18.5C13.5 14.9101 16.4101 12 20 12C23.5899 12 26.5 14.9101 26.5 18.5V20.2761C26.5 20.9521 25.952 21.5 25.2761 21.5H19V23H25.1C25.8732 23 26.5 23.6268 26.5 24.4V30.5H28V18.5C28 14.0817 24.4183 10.5 20 10.5Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzeLogomark);
export default __webpack_public_path__ + "static/media/analyze_logomark.acf92eee33fdbb7bbc17814da872ece2.svg";
export { ForwardRef as ReactComponent };